import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import { useRecoilState } from "recoil";
import { thumnail } from "../../atoms";
import SendIcon from "@mui/icons-material/Send";

function Contact() {
  const goToContact = (e) => {
    e.currentTarget.blur();
    window.open("https://www.mempro.co.kr/contact", "_blank");
  };
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Tooltip title="Contact">
      <IconButton
        aria-label="contact"
        color="primary"
        onClick={(e) => goToContact(e)}
        sx={{ marginRight: isMobile ? 0 : 2 }}
      >
        <SendIcon />
      </IconButton>
    </Tooltip>
  );
}

export default Contact;
